import { Alert, Flex, Skeleton } from "antd"
import VSpace from "../../common/VSpace"
import InvoiceOptionsCard from "./InvoiceOptionsCard"
import { shouldAllowPaymentMethodOnFile, PayInvoiceState, isAlreadyPaid } from "./payInvoiceModel"
import PaymentMethodsCard from "./PaymentMethodsCard"
import PaymentTypeCard from "./PaymentTypeCard"
import { centsToDollarsDisplay } from "../../displayFormatters"
import { InvoicePaymentStatus, PaymentMethodSummary } from "../../../domain/invoicing/payment"

type Props = {
  invoiceTotal: number
  isLoading: boolean
  isError: boolean
  status?: InvoicePaymentStatus
  paymentMethods: PaymentMethodSummary[]
  payInvoiceState: PayInvoiceState
  setPayInvoiceState: (data: PayInvoiceState) => void
  paymentPageUrl: string
  documentLabel?: string
}

const PayInvoice = ({ invoiceTotal, isLoading, isError, status, paymentMethods, payInvoiceState, setPayInvoiceState, paymentPageUrl, documentLabel = 'Invoice' }: Props) => {
  const allowPaymentMethodOnFile = shouldAllowPaymentMethodOnFile(paymentMethods, status)

  if (isLoading) {
    return <Skeleton active />
  }

  if (isError) {
    return <Alert message="Error loading invoicing options." type="error" />
  }

  if (isAlreadyPaid(status)) {
    return <Alert message={`This ${documentLabel.toLowerCase()} already has a recorded payment.`} type="info" />
  }

  return <VSpace>
    <div style={{ maxHeight: '600px', overflowY: 'auto', overflowX: 'clip', scrollbarWidth: 'thin', scrollbarColor: '#00000020 white'}}>
      <VSpace size="large">
        <InvoiceOptionsCard
          allowPaymentMethodOnFile={allowPaymentMethodOnFile}
          selectedOption={payInvoiceState.option}
          onOptionChange={option => setPayInvoiceState({...payInvoiceState, option})}
          paymentPageUrl={paymentPageUrl}
          documentLabel={documentLabel}
        />
        {payInvoiceState.option === 'methodOnFile' && <PaymentMethodsCard
          paymentMethods={paymentMethods}
          selectedPaymentMethodId={payInvoiceState.paymentMethodId}
          onPaymentMethodChange={paymentMethodId => setPayInvoiceState({...payInvoiceState, paymentMethodId})}
          documentLabel={documentLabel}
        />}
        {payInvoiceState.option === 'markPaidManually' && <PaymentTypeCard
          manualPaymentMethod={payInvoiceState.manualPaymentMethod}
          onManualPaymentMethodChange={manualPaymentMethod => setPayInvoiceState({...payInvoiceState, manualPaymentMethod})}
          checkNumber={payInvoiceState.checkNumber}
          onCheckNumberChange={checkNumber => setPayInvoiceState({...payInvoiceState, checkNumber})}
          documentLabel={documentLabel}
        />}
      </VSpace>
    </div>
    <div style={{borderTop: '1px solid #00000026', borderBottom: '1px solid #00000026', padding: '12px 0', fontSize: '16px'}}>
      <Flex justify="space-between" gap={8}>
        <strong>{documentLabel} Total</strong>
        <strong>{centsToDollarsDisplay(invoiceTotal)}</strong>
      </Flex>
    </div>
  </VSpace>
}

export default PayInvoice
